export default __webpack_public_path__ + "static/realization_2-07bf8510edc987a1e8c5b26a4ca5d7c2.jpg";